import { useEffect } from "react";

import { UseSetListingMediaFromHashProps } from "../types";

export const useSetListingMediaFromHash = ({
  combinedMedia,
  hashMap,
  onImageIdFound,
}: UseSetListingMediaFromHashProps) => {
  // Handle initial imageID hash processing on page load only
  useEffect(() => {
    const hashImageId = hashMap.get("imageID");
    if (hashImageId) {
      // find the index of the media item
      const index = combinedMedia.findIndex(
        (media) =>
          media?.external_id === hashImageId || media?.id === hashImageId,
      );
      onImageIdFound(index || 0);
    }
  }, []);
};
